export default {
  "open_platform": "乐福开放平台",
  "faster_cheaper": "更快、更省，轻松开发，快速拥有",
  "what_we_can_do": "我们能做什么",
  "custom_smart_scale": "乐福智能秤定制",
  "build_health_ecosystem": "以智能秤为载体，定制您专属的智能硬件、健康管理App、健康管理平台。一站式打造您的健康管理生态圈。",
  "wechat_mini_program_integration": "微信小程序接入",
  "low_cost_health_mini_program": "低成本打造健康管理小程序。为您提供小程序 OEM 定制、ODM 深度定制以及小程序插件自行开发多种定制模式。",
  "view_docs": "接入文档",
  "app_integration": "App接入",
  "ios_android_sdk": "提供iOS和Android平台SDK，帮助开发者简化开发流程，实现蓝牙协议解析和身体数据计算功能。",
  "massive_food_data": "海量食物数据",
  "easily_access_nutritional_info": "轻松获取食物的营养成分、热量、成分等信息。我们的服务基于权威的食品数据库，覆盖百万种食物。",
  "why_choose_us": "为什么选我们",
  "independent_research": "自主研发",
  "professional_team": "拥有上百人的专业研发团队。我司自主研发并拥有30多项新型实用专利，70多项产品外观专利，20多项软件著作权，并且每年新增专利数量位于行业前茅。经过不断的努力，我司于2016年荣获深圳高新技术企业。从项目设计开发，到成品最终定型，都会由我司强大的研发设计团队层层严格把控。",
  "design_innovation": "设计创新",
  "professional_design_team": "公司拥有专业的设计团队，并与外部专业设计公司保持紧密合作，同时积极赞助多项工业设计创意大赛。我们会提供给每位客户专属设计的ID，定稿后全平台保持唯一性，保障每位客户的产品外观都是独一无二的。",
  "comprehensive_quality_control": "全面品控",
  "market_leader_quality": "作为生产制造企业，品质为市场第一竞争力，公司在2015年导入ISO9001：2015质量体系，在2017年导入ISO13485医疗管理体系，2018年拿到了CFDA生产许可证，公司的品质水平仍在不断提升。在严格要求自身的同时，对供应商也制定了高标准考核管理，从产品源头控制品质。公司品质标准位于全行业顶尖水平。",
  "software_customization": "软件定制",
  "professional_stable_service": "无论是小程序还是APP，我们都能提供专业，安全，稳定的服务。公司拥有本行业最大的软件开发团队，并且成功上线案例达到数百个。各个岗位均有行业资深工程师把控，团队目前成员50余人，并处于高速发展中。",
  "smart_manufacturing": "智能制造",
  "logistics_automation": "乐福的智能制造生产线实现从毛坯上线、加工、质量控制和成品下线全过程的物流输送与自动化生产监控，提高了品控和柔性交付的能力，能更有效地满足不同客户的需求。",
  "dedicated_service": "用心服务",
  "pre_sales": "售前：帮助您了解电子秤市场的行情，加强双方的了解，让您选到满意的产品。",
  "in_sales": "售中：安排产品知识培训；生产前开订单评审会议，保证订单顺利交货，确保产品质量。",
  "after_sales": "售后：全天候在线解答您的任何困难或者疑问。拥有完整的售后服务流程与管理体系。",
  "our_partners": "我们的合作伙伴",
  "learn_more": "立即了解",
  "login_register": "登录/注册",
  "personal_info": "个人信息",
  "logout": "退出登录",
  "language": "语言",
  "contact_email": "联系邮箱",
  "product_center": "产品中心",
  "weight_scale": "体重秤",
  "body_fat_scale": "体脂秤",
  "kitchen_scale": "厨房秤",
  "2in1_nutrition_scale": "2in1营养体脂秤",
  "business_cooperation": "商务合作",
  "cooperation_process": "合作流程",
  "core_advantages": "核心优势",
  "customer_cases": "客户案例",
  "about_us": "关于我们",
  "lefufu_intro": "乐福简介",
  "lefufu_culture": "乐福文化",
  "talent_recruitment": "人才招募",
  "homepage": "首页",
  "document_center": "文档中心",
  "password_login": "密码登录",
  "code_login": "验证码登录",
  "enter_password": "请输入密码",
  "enter_email_or_phone": "请输入邮箱账号、手机号",
  "get_verification_code": "获取验证码",
  "resend": "重新获取",
  "enter_verification_code": "请输入验证码",
  "new_user_register": "新用户使用短信登录自动注册并登录",
  "agree_terms_conditions": "我已阅读并同意",
  "terms_privacy_policy": "服务条款、隐私政策",
  "go_to_register": "去注册",
  "login": "登录",
  "age_required": "年龄不能为空",
  "enter_valid_number": "请输入数字值",
  "must_be_18_or_above": "必须年满18岁",
  "enter_username": "请输入用戶名",
  "enter_valid_phone": "请输入正确的手机号",
  "username_restrictions": "用户名只能包含字母、数字和下划线，长度在3到16个字符",
  "enter_valid_email": "请输入正确的邮箱地址",
  "phone_email_required": "手机号与邮箱不能为空",
  "enter_valid_phone_email": "请输入正确的手机号或邮箱地址",
  "enter_valid_email_email": "请输入正确的邮箱地址或邮箱地址",
  "enter_phone": "请输入手机号",
  "enter_valid_phone_or_email": "请输入有效的手机号码或邮箱",
  "accept_terms_privacy": "需要勾选服务条款、隐私政策",
  "login_success": "登录成功",
  "login_expired": "登录已过期，请重新登录",
  "account_registration": "账号注册",
  "phone_registration": "手机号注册",
  "account": "账号",
  "enter_account": "请输入账号",
  "password": "密码",
  "confirm_password": "确认密码",
  "email": "邮箱号",
  "verification_code": "验证码",
  "phone_number": "手机号",
  "already_have_account": "已有账户？",
  "direct_login": "直接登录",
  "register": "注册",
  "username_restrictions_2": "用户名只能包含字母、数字和下划线，且必须包含一个字母，长度在3到16个字符",
  "password_requirements": "密码长度需要为6-20个数字英文字符",
  "enter_confirm_password": "请输入确认密码",
  "passwords_do_not_match": "两次输入密码不一致",
  "enter_email": "请输入邮箱",
  "basic_information": "基本信息",
  "enter": "请输入",
  "nickname": "昵称",
  "email_2": "邮箱",
  "once_filled_no_changes": "一旦填写将不可修改，请谨慎填写",
  "phone": "电话",
  "registration_date": "注册日期",
  "company_address": "公司地址",
  "position_in_company": "公司职位",
  "select": "请选择",
  "you_dont_have_appkey": "您还没有appKey",
  "copy": "复制",
  "view_my_appkey": "查看我的AppKey",
  "enter_nickname": "请输入昵称",
  "length_between_2_20": "长度在2到20个字符",
  "enter_registration_date": "请输入注册日期",
  "enter_company_name": "请填写公司名称",
  "enter_company_address": "请填写公司地址",
  "select_position": "请选择职位",
  "male": "男",
  "female": "女",
  "secret": "保密",
  "boss": "老板",
  "operations": "运营",
  "development": "开发",
  "product": "产品",
  "other": "其他",
  "copy_success": "配置复制成功",
  "complete_user_company_info": "请先完善用户及公司信息",
  "download_my_config": "下载配置文件",
  "download": "下载",
  "registration_process_document": "注册流程文档",
  "note": "注：如不提供账号可以授权我方账号为开发者",
  "third_party_data_service": "第三方数据服务",
  "operating_document": "操作文档",
  "note2": "注：如不提供相关信息则无法开放此功能",
  "information_related": "信息相关",
  "sender_email": "发件邮箱",
  "default_use": "默认使用",
  "send_password_verification_code_email": "发送密码验证码邮件",
  "sender_email_password": "发件邮箱密码",
  "customer_service_email": "客服邮箱",
  "company_name": "公司名称",
  "language_support": "语言支持",
  "please_select": "请选择",
  "privacy_policy": "隐私政策",
  "user_agreement": "用户协议",
  "company_abbreviation": "公司简称",
  "Joyful_Commerce": "乐福商务",
  "Joyful_Commerce_contact": "乐福商务联系方式",
  "need_to_acquire_first": "需要先获取",
  "age_cannot_be_blank": "年龄不能为空",
  "please_enter_numeric_value": "请输入数字值",
  "please_enter_apple_id": "请输入苹果账号",
  "please_enter_correct_apple_id": "请输入正确的苹果账号",
  "please_enter_google_id": "请输入谷歌账号",
  "please_enter_correct_google_id": "请输入正确的谷歌账号",
  "cannot_be_blank": "不能为空",
  "language_selection_required": "需要选择语言",
  "incorrect": "不正确",
  "format_error": "格式错误",
  "Simplified_Chinese": "中文简体",
  "Chinese_Taiwan": "中国台湾",
  "Arabic": "阿拉伯语",
  "Czech": "捷克语",
  "German": "德语",
  "English": "英语",
  "Spanish": "西班牙语",
  "French": "法语",
  "Hungarian": "匈牙利语",
  "Italian": "意大利语",
  "Japanese": "日语",
  "Korean": "朝鲜语",
  "Dutch": "荷兰语",
  "Polish": "波兰语",
  "Portuguese": "葡萄牙语",
  "Russian": "俄语",
  "Vietnamese": "越南语",
  "Thai": "泰语",
  "Indonesian": "印尼语",
  "Turkish": "土耳其语",
  "Danish": "丹麦语",
  "avatar_image_must_be_JPG": "上传头像图片只能是 JPG 格式!",
  "avatar_image_size_limit_2MB": "上传头像图片大小不能超过 2MB!",
  "default_use_email": "默认使用uniqueLife@healthscale8.com发送密码验证码邮件",
  "developer_information": "开发者信息",
  "custom_data": "定制资料",
  "contact_info_required": "联系方式不能为空",
  "app_key": "我的AppKey",
  "my_device": "我的设备",
  "add_device": "添加设备",
  "device_add_tip": "同一设备型号只需添加一次，无需为每台设备重复添加",
  "no_device_to_download": "暂无设备，请先添加设备后再下载配置文件",
  "please_input": "请输入",
  "device_name": "蓝牙名称(deviceName)",
  "advLength": "广播数据长度(advLength)",
  "sign": "sign",
  "scan_bluetooth_device": "扫描蓝牙设备",
  "rescan_advertisements": "重新扫描广播",
  "bluetooth_retrying": "尚未收到广播，已自动续期继续监听，请保持秤处于广播状态",
  "bluetooth_scanning": "请先踩亮秤唤醒设备，再在浏览器弹窗中选择；显示为“未知或不支持的设备”的通常不是秤，底部按钮仅授权访问不会真正配对",
  "bluetooth_waiting_adv": "正在监听广播（最长 30 秒）：请现在踩亮秤让它处于广播状态，秤的广播窗口很短",
  "bluetooth_scan_success": "蓝牙信息已自动填充，请核对后提交",
  "bluetooth_scan_cancelled": "已取消选择设备",
  "bluetooth_scan_failed": "蓝牙扫描失败，请手动填写或使用手机获取",
  "bluetooth_scan_timeout": "未收到秤的广播：秤广播窗口很短，请重试并在选择设备后立即踩亮秤",
  "bluetooth_adv_not_supported": "已填充蓝牙名称，但当前浏览器无法读取广播数据：新版 Chrome 已移除旧接口，新扫描接口需开启实验特性。请打开 chrome://flags，启用 Experimental Web Platform features 并重启浏览器后重试，或改用手机获取",
  "bluetooth_not_supported": "当前电脑无蓝牙功能或浏览器不支持，请使用手机获取 deviceName、sign、广播数据长度后手动填写",
  "bluetooth_unavailable_tip": "未检测到可用蓝牙，请使用手机获取后手动填写",
  "bluetooth_version_low_tip": "当前浏览器内核低于 Chrome 100，将无法读取广播数据，建议升级浏览器或改用手机",
  "bluetooth_adv_raw": "广播厂商数据（十六进制，仅供参考）",
  "please_fill_in_the_required_fields": "请填写所有必填项",
  "android_access": "Android接入",
  "ios_access": "IOS接入",
  "software_service": "软件服务",
  "enter_phone_or_email": "请输入手机或邮箱",
  "device_setting": "设备配置",
  "device_setting_doc": "注册与配置最佳实践",
  "wait_for": "敬请期待",
  "compare_data": "对比数据",
  "my_ticket": "我的工单",
  "workbench": "工作台",
  "workbench_oem": "OEM 工作台",
  "new_ticket": "新建工单",
  "ticket_number": "工单编号",
  "problem_description": "问题描述",
  "category": "分类",
  "status": "状态",
  "submission_time": "提交时间",
  "operation": "操作",
  "view": "查看",
  "delete": "删除",
  "prompt": "提示",
  "confirm_deletion": "是否删除工单",
  "cancel": "取消",
  "confirm": "确定",
  "title": "标题",
  "upload_attachment": "上传附件",
  "drag_files_here": "将文件拖到此处，或",
  "click_to_upload": "点击上传",
  "select_category": "请选择分类",
  "send_email": "发送邮件",
  "send": "发送",
  "do_not_send": "不发送",
  "access": "接入",
  "mini_program_access": "小程序接入",
  "cloud_computing_library": "云端计算库",
  "device_configuration": "设备配置",
  "awaiting_platform_feedback": "待平台反馈",
  "awaiting_your_feedback": "待您反馈",
  "resolved": "已解决",
  "title_cannot_be_empty": "标题不能为空",
  "problem_description_cannot_be_empty": "问题描述不能为空",
  "category_cannot_be_empty": "分类不能为空",
  "this_is_a_problem_description": "这是一个问题描述",
  "technical_issue": "技术问题",
  "pending": "待处理",
  "reset_to_first_page": "重置为第一页",
  "retrieve_data_again": "重新获取数据",
  "upload_successful": "上传成功",
  "upload_failed": "上传失败",
  "confirm_close": "确认关闭？",
  "reply": "回复",
  "allow_wrapping": "允许换行",
  "wrap_after_exceeding_visible_area": "超出可见区域后自动换行",
  "communication_records": "沟通记录",
  "attachment": "附件",
  "drag_attachment_here": "附件将文件拖到此处，或",
  "submit": "提交",
  "content_cannot_be_empty": "内容不能为空",
  "file_size_exceeds_limit": "上传文件大小不能超过 10MB!",
  "file_already_exists": "该文件已存在，不允许重复上传!",
  "owner_server": "WiFi秤服务器搭建",
  "sou_suo": "搜索",
  "zhong_zhi": "重置",
  "request_url":"请求地址",
  "request_data":"请求（设备 ➜ 服务器）",
  "response_data":"响应（服务器 ➜ 设备）",
  "timestamp":"时间戳",
  "device_configuration_document": "设备配网实践",
  "document_address": "文档地址：",
  "ri_zhi_cha_kan": "日志查看",
  "cao_zuo_jiao_cheng": "操作教程",
  "qing_shu_ru_mac": "请输入Mac地址",
  "dian_ji_da_kai": "点击打开文档",
  "flutter_integration": "Flutter接入",
  "harmony_integration": "Harmony接入",
  "copy_wechat_config": "复制微信小程序配置",
  "holtek_apply_title": "移动端计算库申请",
  "holtek_pkg_placeholder": "请输入包名，例如 com.lefu.uh001",
  "holtek_add_package": "添加包名",
  "holtek_section_list": "包名申请列表",
  "holtek_col_package": "包名",
  "holtek_col_apply_time": "申请时间",
  "holtek_col_status": "状态",
  "holtek_col_secret4": "四电极交流算法",
  "holtek_col_secret8": "八电极交流算法",
  "holtek_status_pending": "申请中",
  "holtek_status_approved": "已通过",
  "holtek_status_renewing": "续签中",
  "holtek_submit_success": "申请提交成功，请等待审核",
  "holtek_pkg_empty": "请填写至少一个包名",
  "holtek_pkg_invalid": "包名格式不正确，仅支持字母、数字、下划线、短横线，以点分隔",
  "holtek_business_manager": "乐福商务经理",
  "holtek_business_manager_placeholder": "请输入乐福商务经理姓名或联系方式",
  "holtek_col_action": "操作",
  "holtek_expire_prefix": "到期：",
  "holtek_renew": "续签",
  "holtek_renew_confirm": "当前授权到期日：{expireDate}（{remain}）。续签将以该包名重新提交申请，重新签发后有效期为签发日起 5 年。是否继续？",
  "holtek_remain_days": "剩余 {n} 天",
  "holtek_remain_today": "今天到期",
  "holtek_remain_expired": "已过期 {n} 天",
  "holtek_remain_unknown": "到期日未知",
  "enter_business_manager": "请输入乐福商务经理姓名或联系方式",
  "business_manager_required_msg": "请先在基本信息中填写乐福商务经理姓名或联系方式，再提交申请",
  "compute_library_apply_title": "云端计算库申请",
  "compute_library_apply_tip": "请根据您的秤型号选择需要申请的算法，提交后等待审批，审批通过后方可调用对应算法接口",
  "compute_library_doc": "接口文档",
  "compute_library_business_manager": "乐福商务经理姓名或联系方式",
  "compute_library_business_manager_placeholder": "请输入乐福商务经理姓名或联系方式",
  "compute_library_select_empty": "请至少选择一个算法",
  "compute_library_not_registered": "未开放",

  // ===== 首页模块文档下拉列表标题 =====
  "mini_plugin_guide": "小程序插件-必要准备和接入指引",
  "mini_plugin_faq": "小程序插件-常见问题",
  "mini_plugin_device_access": "小程序插件-设备接入",
  "mini_plugin_release_notes": "小程序插件_ReleaseNotes",
  "android_sdk_guide": "AndroidSDK-必要准备和接入指引",
  "android_sdk_faq": "AndroidSDK-常见问题",
  "android_sdk_device_access": "AndroidSDK-设备接入",
  "android_sdk_release_notes": "Android_PPBTKitDemo_ReleaseNotes",
  "ios_sdk_guide": "iOS SDK-必要准备和接入指引",
  "ios_sdk_faq": "iOS SDK-常见问题",
  "ios_sdk_device_access": "iOS SDK-设备接入",
  "ios_sdk_release_notes": "iOS_SDK_ReleaseNotes",
  "cloud_library_guide": "云端计算库-必要准备和接入指引",
  "cloud_library_faq": "云端计算库·常见问题",
  "cloud_library_api_reference": "云端计算库·接口参考",
  "cloud_library_release_notes": "云端计算库_ReleaseNotes",
  "open_platform_faq": "开放平台常见问题",
  "open_platform_best_practice": "开放平台注册与配置最佳实践",
  "wifi_server_setup": "WiFi/4G 称服务器搭建-接口实现",
  "wifi_server_release_notes": "WiFi/4G 秤服务端接口ReleaseNotes",
  "wifi_server_faq": "WiFi/4G秤服务端接口开发常见问题",
  "wifi_server_best_practice": "WiFi/4G 称服务器搭建-快速开始",
  "flutter_sdk_guide": "FlutterSDK-必要准备和接入指引",
  "flutter_sdk_faq": "Flutter SDK-常见问题",
  "flutter_sdk_device_access": "Flutter SDK-设备接入",
  "flutter_sdk_release_notes": "Flutter SDK Release Notes",
  "harmony_sdk_guide": "HarmonyOS SDK-必要准备和接入指引",
  "harmony_sdk_faq": "HarmonyOS SDK-常见问题",
  "harmony_sdk_device_access": "HarmonyOS SDK-设备接入",
  "harmony_sdk_release_notes": "HarmonyOS_SDK_ReleaseNotes",

  // ===== 文档中心（DocCenter） =====
  "doc_overview": "概览",
  "doc_overview_guide": "接入总览",
  "doc_overview_guide_desc": "首次接入建议先阅读：了解整体接入流程与各接入方式对比",
  "doc_best_practice_guide": "开放平台注册与配置最佳实践",
  "doc_best_practice_desc": "首次接入建议先阅读：了解开放平台注册与配置的推荐做法与注意事项",
  "doc_group_main": "开发文档",
  "doc_group_support": "支持",
  "doc_count_unit": "篇文档",
  "doc_overview_desc": "本页汇总该接入方式的全部相关文档：接入指引、设备接入、接口参考、常见问题与更新记录。建议从接入指引开始，遇到问题时查阅常见问题或更新记录。",
  "doc_start_guide": "开始接入",
  "doc_open_new_page": "在新页面打开",
  "doc_view_tip": "推荐使用 Chrome 浏览器；如文档提示需要登录飞书，可在新页面直接打开",
  "doc_loading": "文档加载中，请稍候…",
  "doc_not_found": "未找到对应文档，请从左侧目录选择",

  // ===== Workbench (auto-generated) =====
  "wb_001": "OEM 工作台",
  "wb_002": "乐福开放平台 /",
  "wb_003": "上一步",
  "wb_004": "保存草稿",
  "wb_005": "提交数据",
  "wb_006": "下一步",
  "wb_007": "流程进度：",
  "wb_008": "构建流程",
  "wb_009": "创建 App",
  "wb_010": "在 IoT 开发平台新建应用，填写基础信息。",
  "wb_011": "基础信息",
  "wb_012": "必须",
  "wb_013": "应用名称",
  "wb_014": "请输入应用名称",
  "wb_015": "建议中文 ≤ 6 字，英文 ≤ 12 字符",
  "wb_016": "渠道标识符 / Scheme",
  "wb_017": "自动生成",
  "wb_018": "用于唤起 App 的标识（",
  "wb_019": "），供 Deep Link / 推送落地页跳转",
  "wb_020": "Android 应用包名",
  "wb_021": "格式如 com.company.product",
  "wb_022": "iOS 应用包名",
  "wb_023": "建议双端保持一致",
  "wb_024": "版本类型",
  "wb_025": "地区",
  "wb_026": "格式校验全部通过",
  "wb_027": "应用名称、Scheme、双端包名、版本类型与地区均符合规范。",
  "wb_028": "本次会话已提交过审核：版本类型、双端包名与地区",
  "wb_029": "已锁定不可修改",
  "wb_030": "（创建 App 后即不可变的契约要求）。如需调整请重新创建 App。",
  "wb_031": "App 创建后，版本类型、包名和地区均不可修改，请仔细确认后提交。",
  "wb_032": "界面配置",
  "wb_033": "定制 App 的视觉外观，包括图标、主题、模板、启动图和页面组件。",
  "wb_034": "2-A 应用图标",
  "wb_035": "应用图标",
  "wb_036": "内置默认图 · icon_1024.png",
  "wb_037": "下载当前生效的图标，文件名与尺寸即上传要求",
  "wb_038": "下载",
  "wb_039": "2-B 启动图",
  "wb_040": "打包契约要求",
  "wb_041": "4 类",
  "wb_042": "启动资源（背景 / Logo / 底部 / 机型图）× 2 倍率 =",
  "wb_043": "8 张",
  "wb_044": "；缺「启动页背景」会导致启动屏黑屏。 每张卡片可点「下载」获取参考图，",
  "wb_045": "文件名与图片尺寸即上传要求",
  "wb_046": "下载参考图：文件名与尺寸即上传要求",
  "wb_047": "2-C 模板与主题",
  "wb_048": "模板决定预览的布局与明暗模式；主题色 A 会实时同步到预览的主色、渐变与图表，并写入",
  "wb_049": "的",
  "wb_050": "。 主题色 B 暂不开放（不在打包契约内），预览副色使用内置默认值。",
  "wb_051": "主题色 A",
  "wb_052": "品牌名称",
  "wb_053": "（可选）",
  "wb_054": "品牌 Logo",
  "wb_055": "下载已上传的 Logo，便于核对尺寸后重新上传",
  "wb_056": "2-D 页面背景",
  "wb_057": "5 个页面各需 @2x / @3x 两张（共 10 张），ZIP 内按",
  "wb_058": "名称@2x.png",
  "wb_059": "命名。 每个倍率可点「下载」获取参考图，",
  "wb_060": "下载该倍率参考图：文件名与尺寸即上传要求",
  "wb_061": "2-E Tab 栏组件",
  "wb_062": "拖动左侧手柄可调整顺序 —— 顺序即 App 底部导航顺序，会实时同步到右侧预览与提交数据； 手柄聚焦后也可用 ↑ / ↓ 键移动。",
  "wb_063": "调整「",
  "wb_064": "」的顺序",
  "wb_065": "2-F 页面内组件",
  "wb_066": "源文档只给出 5 个页面的名字，未给页面内组件清单，因此当前以",
  "wb_067": "占位项",
  "wb_068": "模拟； 每个页面独立支持显示 / 隐藏与拖拽排序，交互与 2-E 完全一致。",
  "wb_069": "占位",
  "wb_070": "功能配置",
  "wb_071": "App 的设备支持、拓展功能和高级功能配置。",
  "wb_072": "3-A 拓展功能",
  "wb_073": "反馈邮箱",
  "wb_074": "关于页面",
  "wb_075": "App 内关于页底部文字，200 字内",
  "wb_076": "隐私政策 URL",
  "wb_077": "用户协议 URL",
  "wb_078": "3-B 设备配置",
  "wb_079": "会同步到预览「设备」页",
  "wb_080": "设备配置文件",
  "wb_081": "上传配置文件",
  "wb_082": "3-C 计算库 Secret（oem_config.json → calculate）",
  "wb_083": "申请状态",
  "wb_084": "有效期至",
  "wb_085": "平台邮件下发后填写",
  "wb_086": "计算库 Secret 用于身体指标计算（打包必需的",
  "wb_087": "），目前",
  "wb_088": "通过邮件向平台申请",
  "wb_089": "且",
  "wb_090": "带有效期",
  "wb_091": "——过期后成品 App 的身体指标计算会直接失效，请在到期前续期。",
  "wb_092": "3-D 支持的设备型号",
  "wb_093": "已配置型号（按客户定制设备在后台配置）",
  "wb_094": "点击移除 ",
  "wb_095": "尚未配置设备型号",
  "wb_096": "设备型号，如 Miao Scale S1",
  "wb_097": "添加",
  "wb_098": "3-E 模块裁剪",
  "wb_099": "未勾选 = 打包机删除",
  "wb_100": "勾选 = 保留在包内；未勾选的模块会由打包机在构建时从工程中删除（如出海包删友盟、大陆包删 Firebase）。",
  "wb_101": "3-F 高级功能",
  "wb_102": "单位和语言",
  "wb_103": "配置 App 支持的单位制度和多语言选项。",
  "wb_104": "4-A 单位选项",
  "wb_105": "默认重量单位 · defaultUnit",
  "wb_106": "默认长度单位 · defaultLength",
  "wb_107": "支持的重量单位 · unitList",
  "wb_108": "支持的长度单位 · lengthList",
  "wb_109": "4-B 语言配置",
  "wb_110": "默认语言 · defaultLanguage",
  "wb_111": "支持的多语言 · languageList",
  "wb_112": "全选",
  "wb_113": "清空",
  "wb_114": "语言清单对应",
  "wb_115": "（共",
  "wb_116": "种语言代码）。默认启用简体中文与 English，勾选即加入 App 多语言支持；点击右上「全选 / 清空」可批量切换。",
  "wb_117": "构建管理",
  "wb_118": "选择构建用途，生成测试包或正式上架包。",
  "wb_119": "选择构建类型",
  "wb_120": "目标渠道",
  "wb_121": "多选 · 决定产物格式",
  "wb_122": "产物格式由渠道决定：大陆版 → APK；Google Play 版 → AAB Bundle。选错渠道会导致整包作废。",
  "wb_123": "模拟一次失败",
  "wb_124": "体验版有效期 30 天，过期失效。如需正式版请购买 OEM 服务。",
  "wb_125": "失败阶段",
  "wb_126": "错误码",
  "wb_127": "失败原因",
  "wb_128": "处理建议",
  "wb_129": "重试",
  "wb_130": "联系客服",
  "wb_131": "体验版与正式版",
  "wb_132": "了解测试包有效期和正式版购买流程。",
  "wb_133": "项目",
  "wb_134": "体验版（测试）",
  "wb_135": "正式版（购买后）",
  "wb_136": "购买正式版",
  "wb_137": "联系我们",
  "wb_138": "上架配置",
  "wb_139": "正式上架前必须完成的协议、证书和第三方服务配置。",
  "wb_140": "7-A 用户协议 & 隐私政策",
  "wb_141": "填写后会立即出现在预览「我的」页的入口列表里。海外上架必须同时提供英文版协议与隐私政策。",
  "wb_142": "7-B iOS 证书",
  "wb_143": "iOS 证书密码 · iosCerPwd",
  "wb_144": ".p12 导出时设置的密码",
  "wb_145": "oem_config.json 必填字段，签名时使用，提交后脱敏",
  "wb_146": "Apple 开发者账号",
  "wb_147": "7-C Android 证书",
  "wb_148": "Android 签名密钥文件",
  "wb_149": "Android 签名文件",
  "wb_150": "Keystore 密码 · keyStorePwd",
  "wb_151": "签名文件（.jks）本身的密码",
  "wb_152": "Key 别名",
  "wb_153": "Key 密码 · keyAliasPwd",
  "wb_154": "别名对应私钥的密码 ——",
  "wb_155": "与 Keystore 密码是两个独立密码",
  "wb_156": "，极易填混",
  "wb_157": "GIDClientID（Google 登录授权 ID）",
  "wb_158": "oem_config.json 契约字段；Google 登录需要，向平台申请后填写",
  "wb_159": "7-E 上架信息",
  "wb_160": "公司名称",
  "wb_161": "联系邮箱",
  "wb_162": "联系人",
  "wb_163": "联系人电话",
  "wb_164": "应用类型（商店类目）",
  "wb_165": "Copyright 名称",
  "wb_166": "公司介绍",
  "wb_167": "支持网站",
  "wb_168": "Google 上架账号",
  "wb_169": "Google Play 控制台账号",
  "wb_170": "Apple 上架账号",
  "wb_171": "App Store Connect 账号",
  "wb_172": "搜索关键字",
  "wb_173": "+ 添加",
  "wb_174": "商店搜索优化用词",
  "wb_175": "输入关键字后点「+ 添加」或回车",
  "wb_176": "上架国家 / 地区",
  "wb_177": "应用可上架的国家 / 地区",
  "wb_178": "如：中国大陆、新加坡",
  "wb_179": "应用描述",
  "wb_180": "构建渠道（大陆版 / Google Play 版）在第 5 步「目标渠道」选择。iOS 审核较严格：确保双语法务文本、证书材料与上架信息完整准确，常见驳回原因包括隐私政策缺失、测试账号未提供。",
  "wb_181": "常用工具",
  "wb_182": "上架后的增强配置和运营辅助工具。",
  "wb_183": "二维码生成",
  "wb_184": "绑定各商店链接，生成永久二维码用于包装印刷。",
  "wb_185": " 二维码",
  "wb_186": "清除",
  "wb_187": "蒲公英 · 内测分发",
  "wb_188": "上传安装包到蒲公英",
  "wb_189": "测试包可通过蒲公英分发给内测用户，无需应用商店审核。",
  "wb_190": "复制分发链接",
  "wb_191": "已复制蒲公英分发短链（模拟）",
  "wb_192": "流程完成",
  "wb_193": "恭喜！",
  "wb_194": "您已完成所有配置步骤。可以通过「构建管理」生成正式包并提交应用商店审核。",
  "wb_195": "数据与提交",
  "wb_196": "后端接口尚未接入，当前由本地模拟数据层提供数据来源与提交过程，提交不会发出真实网络请求。",
  "wb_197": "9-A 数据来源与草稿",
  "wb_198": "数据来源",
  "wb_199": "草稿保存时间",
  "wb_200": "自动保存",
  "wb_201": "字段完成度",
  "wb_202": "重新拉取（模拟服务端）",
  "wb_203": "立即保存草稿",
  "wb_204": "重置为示例数据",
  "wb_205": "9-B 提交字段清单",
  "wb_206": "只看必填",
  "wb_207": "只看未填写",
  "wb_208": "只看影响预览",
  "wb_209": "步骤",
  "wb_210": "字段",
  "wb_211": "当前值",
  "wb_212": "必填",
  "wb_213": "影响预览",
  "wb_214": "当前筛选条件下没有字段",
  "wb_215": "9-C 提交审核",
  "wb_216": "补齐必填项后按钮自动可用",
  "wb_217": "提交单号与记录会写入浏览器本地存储",
  "wb_218": "提交成功：单号",
  "wb_219": "9-D 提交记录",
  "wb_220": "单号",
  "wb_221": "类型",
  "wb_222": "应用",
  "wb_223": "时间",
  "wb_224": "状态",
  "wb_225": "暂无记录，执行「开始构建」或「提交审核」后会写入本地记录",
  "wb_226": "清空记录",
  "wb_227": "9-E 资源包内容预览（打包机输入）",
  "wb_228": "「Web 平台 → 打包机」的唯一切面是 ZIP 资源包：根目录",
  "wb_229": "1 个",
  "wb_230": "（含",
  "wb_231": "五块子配置）+ 3 个证书，",
  "wb_232": "与",
  "wb_233": "放图片。真实 ZIP 由后端打包，这里预览打包机将拿到的输入。",
  "wb_234": "图片资源（oem_config.json → ios / android）",
  "wb_235": "点击后先弹确认框，确认后才会批量上传：应用图标、启动图 8 张（背景 / Logo / 底部 / 机型图 × @2x @3x）、 登录页 / 首页浅色 / 首页暗黑背景各",
  "wb_236": "只上传一次",
  "wb_237": "，两端字段同步写入同一链接；",
  "wb_238": "没有上传替换的资源位",
  "wb_239": "（当前显示内置默认图）也会写入字段，值为默认图地址， 保证",
  "wb_240": "节点字段齐全。",
  "wb_241": "9-F 提交载荷 JSON",
  "wb_242": "实时预览",
  "wb_243": "启动屏",
  "wb_244": "登录页",
  "wb_245": "浅",
  "wb_246": "暗",
  "wb_247": "预览缩放（在预览区按 Ctrl / ⌘ + 滚轮也可以调整）",
  "wb_248": "缩小预览",
  "wb_249": "点击恢复 100%",
  "wb_250": "放大预览",
  "wb_251": "（默认图）",
  "wb_252": "请输入手机号",
  "wb_253": "请输入验证码",
  "wb_254": "登 录",
  "wb_255": "用户协议",
  "wb_256": "隐私政策",
  "wb_257": "页面内组件",
  "wb_258": "还差一点 —— 填写「3-A 拓展功能」里的关于/隐私政策/用户协议/反馈邮箱后，这里会自动出现对应的入口。",
  "wb_259": "配置文件",
  "wb_260": "AppKey 来自「3-B 设备配置」",
  "wb_261": "未启用任何页面",
  "wb_262": "在「2-E Tab 栏组件」打开开关即可恢复预览",
  "wb_263": "当前步骤",
  "wb_264": "页面模板",
  "wb_265": "主题色",
  "wb_266": "已启用页面",
  "wb_267": "背景 / 启动图",
  "wb_268": "联动字段",
  "wb_269": "联动更新日志",
  "wb_270": "修改「界面配置」或「功能配置」里的任意联动项，这里会记录每次同步。",
  "wb_271": "正在从本地模拟服务拉取工作台数据…",
  "wb_272": "已应用页面背景：",
  "wb_273": "（",
  "wb_274": "）",
  "wb_275": "，",
  "wb_276": "。",
  "wb_277": "：",
  "wb_278": "、",
  "wb_279": "「",
  "wb_280": "」",
  "wb_281": "—",
  "wb_282": "格式校验未通过：",
  "wb_283": " 项错误",
  "wb_284": " 项建议",
  "wb_285": "格式校验通过，",
  "wb_286": "项齐",
  "wb_287": "占位模拟中",
  "wb_288": "提交载荷中脱敏为 ",
  "wb_289": "上架目标：",
  "wb_290": "基础信息与格式校验",
  "wb_291": "视觉外观定制",
  "wb_292": "设备与拓展功能",
  "wb_293": "多语言与单位",
  "wb_294": "测试与上架包",
  "wb_295": "版本管理",
  "wb_296": "协议、证书与信息",
  "wb_297": "二维码与运营",
  "wb_298": "模拟数据与提交过程",
  "wb_299": "资源清单",
  "wb_300": "测试使用",
  "wb_301": "生成双端测试二维码，扫码安装体验",
  "wb_302": "仅需完成基础配置（步骤 1-3）",
  "wb_303": "正式上架",
  "wb_304": "生成可提交应用商店的安装包",
  "wb_305": "需完成所有上架配置",
  "wb_306": "Android 测试包",
  "wb_307": "iOS 测试包",
  "wb_308": "有效期",
  "wb_309": "默认 30 天",
  "wb_310": "永久有效",
  "wb_311": "商店发布",
  "wb_312": "不可用于商店发布",
  "wb_313": "可提交各大应用商店",
  "wb_314": "获取方式",
  "wb_315": "构建后扫码安装",
  "wb_316": "购买 OEM 服务后构建",
  "wb_317": "额外能力",
  "wb_318": "修改应用名称、历史版本、更新模板、数据分析",
  "wb_319": "付款方式",
  "wb_320": "在线支付 / 线下付款绑定",
  "wb_321": "用户协议（中文）",
  "wb_322": "「我的 → 用户协议」跳转地址，上架必填",
  "wb_323": "隐私政策（中文）",
  "wb_324": "「我的 → 隐私政策」跳转地址，上架必填",
  "wb_325": "用户协议（英文）",
  "wb_326": "Terms of Service，海外上架必需",
  "wb_327": "隐私政策（英文）",
  "wb_328": "Privacy Policy，海外上架必需",
  "wb_329": "绑定 App Store 链接",
  "wb_330": "绑定 Google Play 链接",
  "wb_331": "请选择版本类型",
  "wb_332": "请选择地区",
  "wb_333": "本地草稿（localStorage 模拟服务端）",
  "wb_334": "内置示例数据",
  "wb_335": "拉取草稿中…",
  "wb_336": "草稿已自动保存 ",
  "wb_337": "草稿已同步",
  "wb_338": "示例数据",
  "wb_339": "数据来源：",
  "wb_340": "；最近保存：",
  "wb_341": "（空）",
  "wb_342": "背景",
  "wb_343": "底部",
  "wb_344": "机型图",
  "wb_345": "· 默认图",
  "wb_346": "默认图",
  "wb_347": "待上传",
  "wb_348": "未配置，暂用主题渐变",
  "wb_349": "内置默认图 ·",
  "wb_350": "已配置 ·",
  "wb_351": "·默认图",
  "wb_352": "BG·首页头部",
  "wb_353": "BG·个人中心",
  "wb_354": "登录页背景",
  "wb_355": "未命名页面",
  "wb_356": ".p12 证书文件",
  "wb_357": "未上传",
  "wb_358": ".p8 密钥（可选）",
  "wb_359": "部分上架场景需要",
  "wb_360": "关联 App ID 的描述文件",
  "wb_361": "待申请",
  "wb_362": "（未设置有效期）",
  "wb_363": "已过期",
  "wb_364": "天 · 指标计算已失效",
  "wb_365": "仅剩",
  "wb_366": "天，请尽快续期",
  "wb_367": "剩余",
  "wb_368": "天",
  "wb_369": "等",
  "wb_370": "已分发",
  "wb_371": "项",
  "wb_372": "未设置",
  "wb_373": "关于我们",
  "wb_374": "已配置",
  "wb_375": "意见反馈",
  "wb_376": "默认语言",
  "wb_377": "未命名应用",
  "wb_378": "未设置品牌",
  "wb_379": "早上好",
  "wb_380": "暗黑",
  "wb_381": "浅色",
  "wb_382": "该页暂无可预览的组件，去「2-F 页面内组件」确认。",
  "wb_383": "该页面的",
  "wb_384": "个组件已全部隐藏，预览里不再显示。",
  "wb_385": "智能",
  "wb_386": "体脂秤",
  "wb_387": "未配置",
  "wb_388": "使用默认配置",
  "wb_389": "张",
  "wb_390": "已生成渠道标识符：",
  "wb_391": "已从本地草稿恢复配置",
  "wb_392": "已加载内置示例数据",
  "wb_393": "已重置为内置示例数据",
  "wb_394": "草稿已保存（localStorage 模拟服务端）",
  "wb_395": "已切换模板：",
  "wb_396": "（预览已同步）",
  "wb_397": "已启用「",
  "wb_398": "已隐藏「",
  "wb_399": "」Tab 栏组件",
  "wb_400": "已切换到「",
  "wb_401": "」的组件清单",
  "wb_402": "已显示「",
  "wb_403": "」已移到第 ",
  "wb_404": " 位",
  "wb_405": "」已",
  "wb_406": "上移",
  "wb_407": "下移",
  "wb_408": "已开启「",
  "wb_409": "已关闭「",
  "wb_410": "」数据同步",
  "wb_411": "已启用全部 30 种语言",
  "wb_412": "已清空语言清单",
  "wb_413": "暂无可下载的图片，请先上传或稍后重试",
  "wb_414": "已开始下载：",
  "wb_415": "（文件名与尺寸即上传要求）",
  "wb_416": "页面背景",
  "wb_417": "已上传：",
  "wb_418": "（点击替换）",
  "wb_419": "当前显示内置默认图（点击上传 @",
  "wb_420": "x 替换）",
  "wb_421": "点击上传 @",
  "wb_422": " · ",
  "wb_423": "已选择",
  "wb_424": "文件",
  "wb_425": "安装包已上传蒲公英（模拟）：",
  "wb_426": "还没有可上传的图片，请先在第 2 步上传应用图标 / 启动图 / 页面背景",
  "wb_427": "将上传 ",
  "wb_428": "张图片，写入 ",
  "wb_429": "个字段（",
  "wb_430": "iOS 与 Android 共用的应用图标只传一次、两端同步写入；未上传替换的资源位会写入内置默认图地址。是否继续？",
  "wb_431": "批量上传图片",
  "wb_432": "确认上传",
  "wb_433": "取消",
  "wb_434": "已取消上传",
  "wb_435": "准备上传 0 / ",
  "wb_436": "正在上传 ",
  "wb_437": "[oem image] 本地没有找到文件：",
  "wb_438": "[oem image] 上传失败：",
  "wb_439": "上传返回中没有图片地址",
  "wb_440": " 张，",
  "wb_441": " 张失败（可在控制台查看详情）",
  "wb_442": " 张图片，链接已写入 oem_config.json",
  "wb_443": "正式包",
  "wb_444": "测试包",
  "wb_445": "还缺 ",
  "wb_446": "项必填配置（",
  "wb_447": "），构建前请先补齐",
  "wb_448": "Android 正式包",
  "wb_449": "iOS 正式包",
  "wb_450": "构建",
  "wb_451": "构建失败",
  "wb_452": "构建失败：",
  "wb_453": "构建成功",
  "wb_454": "构建成功（",
  "wb_455": "），可扫码安装体验",
  "wb_456": "至少保留一个构建渠道",
  "wb_457": "已移除渠道：",
  "wb_458": "已添加渠道：",
  "wb_459": "（产物 ",
  "wb_460": "还有 ",
  "wb_461": " 项必填字段未完成",
  "wb_462": "提交后「版本类型 / 双端包名 / 地区」将锁定且不可修改。\n",
  "wb_463": "版本类型：",
  "wb_464": "正式版",
  "wb_465": "体验版",
  "wb_466": "，Android 包名：",
  "wb_467": "，地区：",
  "wb_468": "中国大陆",
  "wb_469": "海外",
  "wb_470": "\n确认提交？",
  "wb_471": "提交审核",
  "wb_472": "已提交",
  "wb_473": "提交成功：",
  "wb_474": "（版本类型 / 包名 / 地区 已锁定）",
  "wb_475": "本地提交记录已清空",
  "wb_476": "已进入正式版购买流程",
  "wb_477": "已为您转接商务顾问，请留意来电",
  "wb_478": "二维码已下载：",
  "wb_479": "当前环境不支持直接下载，已在新窗口打开二维码",
  "wb_480": "蒲公英安装包",
  "wb_481": "型号「",
  "wb_482": "」已存在",
  "wb_483": "已添加设备型号：",
  "wb_484": "已移除设备型号：",
  "wb_485": "构建中…",
  "wb_486": "开始构建",
  "wb_487": "重新上传",
  "wb_488": "上传",
  "wb_489": "替换",
  "wb_490": "下载二维码",
  "wb_491": "请先绑定链接",
  "wb_492": "提交中…",
  "wb_493": "收起",
  "wb_494": "展开",
  "wb_495": "已连接",
  "wb_496": "未连接",
  "wb_497": "可选",
  "wb_498": "未保存",
  "wb_499": "待触发",
  "wb_500": "已保存 ",
  "wb_501": "预览用",
  "wb_502": "尚未上传应用图标",
  "wb_503": "当前展示内置默认图标；建议 1024 x 1024 px PNG，无透明边距",
  "wb_504": "上传 Logo",
  "wb_505": "已具备（上架前提）",
  "wb_506": "未确认 —— 上架前需先具备 Apple 开发者账号",
  "wb_507": "未上传 .jks / .keystore",
  "wb_508": "重新上传 APK / IPA",
  "wb_509": "上传 APK / IPA",
  "wb_510": "编译双端资源包",
  "wb_511": "签名并生成二维码",
  "wb_512": "错误",
  "wb_513": "建议",
  "wb_514": "上传中…",
  "wb_515": "必填字段 ",
  "wb_516": " 项已全部填写，可以提交。提交过程为本地模拟：校验 → 打包 → 上传 → 提交审核。",
  "wb_517": " 项必填字段未完成：",
  "wb_518": " 条",
  "wb_519": " 个资源 · ",
  "wb_520": " 项缺失",
  "wb_521": " 个资源位 × 2 平台 = ",
  "wb_522": " 个字段 · ",
  "wb_523": "已上传替换 ",
  "wb_524": " 个 · 可上传 ",
  "wb_525": " 个",
  "wb_526": " · 敏感字段（AppSecret / Keystore 密码）已脱敏",
  "wb_527": "启动图 ",
  "wb_528": "· 背景取 @",
  "wb_529": "x",
  "wb_530": " 显示",
  "wb_531": "默认语言：",
  "wb_532": " · 支持 ",
  "wb_533": " 种语言",
  "wb_534": " 已启用",
  "wb_535": "前往修复（第 ",
  "wb_536": " 步）",
  "wb_537": " 构建失败（单号 ",
  "wb_538": "）：请根据下方提示逐项检查，或联系平台客服。",
  "wb_539": "构建成功！构建单号 ",
  "wb_540": "，扫码安装体验",
  "wb_541": "步",
  "wb_542": "项齐 ·",
  "wb_543": "打包文件名：",
  "wb_544": "@2x.png ·",
  "wb_545": "占",
  "wb_546": "正在",
  "wb_547": "…（本地模拟构建过程）",
  "wb_548": "已上传",
  "wb_549": "%）",
  "wb_550": "个字段",
  "wb_551": "，应用",
  "wb_552": "），模拟耗时",
  "wb_553": "ms，提交时间",
  "wb_554": "个字段 · 已上传替换",
  "wb_555": "· appId",
  "wb_556": "…",
  "wb_557": "）。",
  "wb_558": "项必填配置，已定位到第 ",
  "wb_559": "点击后先弹确认框，确认后才会批量上传：应用图标、启动图 8 张（背景 / Logo / 底部 / 机型图 × @2x @3x）、 登录页 / 首页浅色 / 首页暗黑背景各 @2x @3x、个人中心浅色与暗黑 @2x，共 17 个资源位。 iOS 与 Android 共用的应用图标",
  "wb_560": "iOS 与 Android 共用的应用图标只上传一次 ，两端字段同步写入同一链接；",
  "wb_561": " · 待上传",


  // ===== workbenchMock 数据层文案（tl() 查表） =====
  "wbm_001": "(由表单生成)",
  "wbm_002": "Android 包名",
  "wbm_003": "Android 应用包名",
  "wbm_004": "Android 测试包",
  "wbm_005": "Android 签名待上传",
  "wbm_006": "Android 签名文件",
  "wbm_007": "App 主入口，健康概览",
  "wbm_008": "Apple 上架账号",
  "wbm_009": "Copyright 名称",
  "wbm_010": "GIDClientID（Google 登录）",
  "wbm_011": "Google Play 版",
  "wbm_012": "Google 上架账号",
  "wbm_013": "Key 别名",
  "wbm_014": "Key 密码 keyAliasPwd",
  "wbm_015": "Keystore 密码 keyStorePwd",
  "wbm_016": "Miao Health - 智能健康管理助手，记录您的每一步健康数据。",
  "wbm_017": "Miao Health 是一款专注于健康管理的智能应用，帮助用户记录和分析健康数据。",
  "wbm_018": "Miao Technology 专注智能健康硬件与软件服务，提供体脂秤、手环等设备的配套 App 定制。",
  "wbm_019": "Secret 已下发，请填写到下方并留意有效期",
  "wbm_020": "Tab 栏组件",
  "wbm_021": "iOS .p12 证书",
  "wbm_022": "iOS .p8 密钥",
  "wbm_023": "iOS 包名",
  "wbm_024": "iOS 应用包名",
  "wbm_025": "iOS 描述文件",
  "wbm_026": "iOS 描述文件待上传",
  "wbm_027": "iOS 测试包",
  "wbm_028": "iOS 签名材料缺失：.p12 证书 / 描述文件 / 证书密码不完整",
  "wbm_029": "iOS 证书密码 iosCerPwd",
  "wbm_030": "iOS 证书（.p12）待上传",
  "wbm_031": "oem_config.json 字段，平台申请",
  "wbm_032": "oem_config.json 必填",
  "wbm_033": "oem_config.json 必填（与 Keystore 密码是两个密码）",
  "wbm_034": "· 待定稿",
  "wbm_035": "—（原「数据」页同步入口已随内置假数据移除，待接入真实组件）",
  "wbm_036": "—（待接入真实组件）",
  "wbm_037": "「我的」页关于我们",
  "wbm_038": "「我的」页意见反馈",
  "wbm_039": "「我的」页用户协议",
  "wbm_040": "「我的」页隐私政策",
  "wbm_041": "「设备」页设备信息",
  "wbm_042": "」是 Java 保留字，不能用于包名",
  "wbm_043": "」是系统保留 scheme，请更换",
  "wbm_044": "上传构建产物",
  "wbm_045": "上架国家 / 地区",
  "wbm_046": "上架配置",
  "wbm_047": "与 Android 包名不一致，建议双端保持一致",
  "wbm_048": "个人中心 - 暗黑",
  "wbm_049": "个人中心 - 浅色",
  "wbm_050": "个人中心与设置",
  "wbm_051": "个人中心（暗黑）@2x",
  "wbm_052": "个人中心（浅色）@2x",
  "wbm_053": "个字符",
  "wbm_054": "个字符，超过建议的",
  "wbm_055": "个组件",
  "wbm_056": "个页面 · 启用",
  "wbm_057": "中国大陆",
  "wbm_058": "中文",
  "wbm_059": "中文名",
  "wbm_060": "主题色 A",
  "wbm_061": "仅用于测试分发，有效期 30 天",
  "wbm_062": "体重管理",
  "wbm_063": "体重趋势",
  "wbm_064": "体验版",
  "wbm_065": "保留：",
  "wbm_066": "健康",
  "wbm_067": "健康健美",
  "wbm_068": "公司介绍",
  "wbm_069": "公司名称",
  "wbm_070": "关于页面文案",
  "wbm_071": "内置示例数据（首次进入）",
  "wbm_072": "决定产物格式：大陆版 APK / GP 版 AAB",
  "wbm_073": "准备构建环境",
  "wbm_074": "前往「2-B 启动图」上传后重试",
  "wbm_075": "功能配置",
  "wbm_076": "包名只能使用小写字母",
  "wbm_077": "包装印刷二维码",
  "wbm_078": "医疗",
  "wbm_079": "千克 (kg)",
  "wbm_080": "千克 kg",
  "wbm_081": "单位和语言",
  "wbm_082": "占位组件",
  "wbm_083": "厘米 (cm)",
  "wbm_084": "厘米 cm",
  "wbm_085": "友盟统计",
  "wbm_086": "反馈邮箱",
  "wbm_087": "只能包含小写字母、数字以及 - + . 三种符号",
  "wbm_088": "可提交应用商店，永久有效",
  "wbm_089": "可选（部分上架场景）",
  "wbm_090": "同步健康数据给 Apple Health",
  "wbm_091": "同步健康数据给 Health Connect",
  "wbm_092": "否",
  "wbm_093": "含本土化 Push / 统计服务",
  "wbm_094": "启动图（8 张：背景 / Logo / 底部 / 机型图 × @2x@3x）",
  "wbm_095": "启动屏预览",
  "wbm_096": "启动页 Logo",
  "wbm_097": "启动页 Logo @2x",
  "wbm_098": "启动页 Logo @3x",
  "wbm_099": "启动页底部",
  "wbm_100": "启动页底部 @2x",
  "wbm_101": "启动页底部 @3x",
  "wbm_102": "启动页机型 / 外壳底图，可用平台占位图（名称以打包机契约为准）",
  "wbm_103": "启动页机型图",
  "wbm_104": "启动页机型图 @2x",
  "wbm_105": "启动页机型图 @3x",
  "wbm_106": "启动页背景",
  "wbm_107": "启动页背景 @2x",
  "wbm_108": "启动页背景 @3x",
  "wbm_109": "品牌 Logo",
  "wbm_110": "品牌名称",
  "wbm_111": "唤起 App 的标识（Deep Link）；写入 oem_config.json 的 scheme",
  "wbm_112": "商店类目",
  "wbm_113": "商店链接（永久二维码）",
  "wbm_114": "国内统计 SDK，大陆版建议保留",
  "wbm_115": "地区",
  "wbm_116": "地区取值非法：",
  "wbm_117": "基础信息",
  "wbm_118": "大陆版",
  "wbm_119": "天气 / 运动轨迹",
  "wbm_120": "字，桌面图标下易被截断",
  "wbm_121": "字，超过建议的",
  "wbm_122": "官网 / 国内应用市场",
  "wbm_123": "定位 SDK",
  "wbm_124": "尚未向平台邮件申请计算库 Secret，打包前必须完成",
  "wbm_125": "居中品牌 Logo",
  "wbm_126": "工具",
  "wbm_127": "已上传",
  "wbm_128": "已下发",
  "wbm_129": "已分发",
  "wbm_130": "已申请",
  "wbm_131": "市斤",
  "wbm_132": "常用工具",
  "wbm_133": "广告 SDK",
  "wbm_134": "应用名称",
  "wbm_135": "应用名称最多",
  "wbm_136": "应用图标",
  "wbm_137": "应用图标待上传（1024×1024 PNG）",
  "wbm_138": "应用描述",
  "wbm_139": "应用类型",
  "wbm_140": "底部版权 / 标语区",
  "wbm_141": "建议全部使用小写字母（如",
  "wbm_142": "开屏 / 激励广告",
  "wbm_143": "张",
  "wbm_144": "张）",
  "wbm_145": "待申请",
  "wbm_146": "必需资源缺失：PIC_Launch_Image（启动页背景）",
  "wbm_147": "必须以小写字母开头",
  "wbm_148": "我的",
  "wbm_149": "手表端扩展（仅 iOS）",
  "wbm_150": "打包应用资源",
  "wbm_151": "打包必需 · 邮件申请 · 带有效期",
  "wbm_152": "按客户设备在后台配置",
  "wbm_153": "提交应用商店审核",
  "wbm_154": "搜索关键字",
  "wbm_155": "支持的单位 · 重量 unitList",
  "wbm_156": "支持的单位 · 长度 lengthList",
  "wbm_157": "支持的多语言 languageList（30 种）",
  "wbm_158": "支持的设备型号",
  "wbm_159": "支持网站",
  "wbm_160": "数据",
  "wbm_161": "数据趋势图表与分析",
  "wbm_162": "数组",
  "wbm_163": "数组，商店搜索优化",
  "wbm_164": "整屏背景图，需与启动页 Logo 叠加后不遮挡",
  "wbm_165": "斤",
  "wbm_166": "日本語",
  "wbm_167": "是",
  "wbm_168": "智能秤",
  "wbm_169": "暗黑专业",
  "wbm_170": "未上传",
  "wbm_171": "未勾选模块由打包机删除",
  "wbm_172": "本地草稿（localStorage 模拟服务端）",
  "wbm_173": "构建管理",
  "wbm_174": "校验配置完整性",
  "wbm_175": "格式应为 com.company.product（至少两段，每段以小写字母开头，仅含小写字母 / 数字 / 下划线）",
  "wbm_176": "模块裁剪（保留项）",
  "wbm_177": "正式包必须双端签名材料齐全，请前往「7-B iOS 证书」补齐后重试",
  "wbm_178": "正式版",
  "wbm_179": "段落「",
  "wbm_180": "活力卡片",
  "wbm_181": "测试包分发",
  "wbm_182": "海外",
  "wbm_183": "海外上架必需",
  "wbm_184": "海外分析 / Crash / 推送",
  "wbm_185": "渠道标识符 / Scheme",
  "wbm_186": "渠道标识符 Scheme",
  "wbm_187": "版本类型",
  "wbm_188": "版本类型取值非法：",
  "wbm_189": "王小明",
  "wbm_190": "用户协议 URL",
  "wbm_191": "用户协议（中文）",
  "wbm_192": "用户协议（英文）",
  "wbm_193": "申请邮件已发出，等待平台下发（一般 1-2 个工作日）",
  "wbm_194": "界面配置",
  "wbm_195": "登录页背景",
  "wbm_196": "登录页背景 @2x",
  "wbm_197": "登录页背景 @3x",
  "wbm_198": "目标渠道（大陆版 / Google Play 版）",
  "wbm_199": "磅 (lb)",
  "wbm_200": "磅 lb",
  "wbm_201": "种：",
  "wbm_202": "签名并生成二维码",
  "wbm_203": "简体中文",
  "wbm_204": "简约清新",
  "wbm_205": "繁體中文",
  "wbm_206": "经典健康",
  "wbm_207": "维度数据",
  "wbm_208": "编译双端资源包",
  "wbm_209": "联系人",
  "wbm_210": "联系人电话",
  "wbm_211": "联系邮箱",
  "wbm_212": "英寸 (in)",
  "wbm_213": "英寸 inch",
  "wbm_214": "英文名",
  "wbm_215": "英石 st",
  "wbm_216": "英石+磅 st:lb",
  "wbm_217": "蒲公英内测分发",
  "wbm_218": "计算库 Secret（oem_config.json → calculate）",
  "wbm_219": "设备",
  "wbm_220": "设备管理与连接",
  "wbm_221": "设备配置文件",
  "wbm_222": "该包名已被占用，请更换",
  "wbm_223": "请填写",
  "wbm_224": "请填写应用名称",
  "wbm_225": "请填写渠道标识符 / Scheme",
  "wbm_226": "请选择地区",
  "wbm_227": "请选择版本类型",
  "wbm_228": "趋势",
  "wbm_229": "趋势页",
  "wbm_230": "身体数据",
  "wbm_231": "身体数据详情与记录",
  "wbm_232": "运动健身",
  "wbm_233": "近 30 天体重曲线 · 示例组件（src/components/workbench-preview/）",
  "wbm_234": "长度需为",
  "wbm_235": "隐私政策 URL",
  "wbm_236": "隐私政策（中文）",
  "wbm_237": "隐私政策（英文）",
  "wbm_238": "面向 Google Play 商店",
  "wbm_239": "页面内组件（5 个页面）",
  "wbm_240": "页面模板",
  "wbm_241": "页面背景（每项 @2x/@3x）",
  "wbm_242": "项齐（图",
  "wbm_243": "项（启用",
  "wbm_244": "预览品牌行 / 启动屏",
  "wbm_245": "预览图标渐变 / 启动屏背景；写入 oem_config.json → colors.light/dark.brand_100（不透明 ARGB）",
  "wbm_246": "预览头像 / 启动屏图标",
  "wbm_247": "预览布局 / 暗黑模式",
  "wbm_248": "预览底部导航（含顺序）",
  "wbm_249": "预览标题 / 启动屏",
  "wbm_250": "预览背景角标",
  "wbm_251": "预览问候语语言 / 「我的」页默认语言",
  "wbm_252": "饮食数据",
  "wbm_253": "首页",
  "wbm_254": "首页 / 趋势 / 数据 页的组件清单（含顺序）",
  "wbm_255": "首页头部 - 暗黑",
  "wbm_256": "首页头部 - 浅色",
  "wbm_257": "首页头部（暗黑）@2x",
  "wbm_258": "首页头部（暗黑）@3x",
  "wbm_259": "首页头部（浅色）@2x",
  "wbm_260": "首页头部（浅色）@3x",
  "wbm_261": "高级功能",
  "wbm_262": "默认简体中文 / 公制，接入本土化服务",
  "wbm_263": "默认英文 / 英制，接入 Google 服务",
  "wbm_264": "默认语言 defaultLanguage",
  "wbm_265": "默认重量单位 defaultUnit",
  "wbm_266": "默认长度单位 defaultLength",
  "wbm_267": "（全部裁剪）",
  "wbm_268": "（无可选组件）",
  "wbm_269": "（未启用）",
  "wbm_270": "（未开启）",
  "wbm_271": "（未绑定商店链接）",
  "wbm_272": "（未选择渠道）",
  "wbm_273": "（未配置设备型号）",
  "wbm_274": "（空）",
  "wbm_275": "；与 Android 包名不一致，建议双端保持一致",
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh_CN.js